import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import { isSpecified } from './util';
import MissingValue from './MissingValue';
/**
 * @param {import('./types').ListFormatterProps<any>} props
 **/

var ListFormatter = function ListFormatter(_ref) {
  var value = _ref.value,
      render = _ref.render,
      separator = _ref.separator,
      fallback = _ref.fallback,
      maxCount = _ref.maxCount,
      renderMore = _ref.renderMore,
      rest = _objectWithoutProperties(_ref, ["value", "render", "separator", "fallback", "maxCount", "renderMore"]);

  var hasValue = isSpecified(value);
  if (!hasValue) return fallback;
  if (value.length === 0) return fallback;
  var options = [];
  var restElements = 0;
  if (maxCount > 0) restElements = value.length - maxCount;

  if (restElements > 0) {
    for (var i = value.length - restElements; i < value.length; i++) {
      var option = {
        label: value[i].Name,
        onClick: null
      };
      options.push(option);
    }

    return React.createElement("span", rest, value.map(function (t, idx) {
      return React.createElement(React.Fragment, {
        key: idx
      }, idx < maxCount ? render(t, idx) : null, idx < maxCount - 1 ? separator : null);
    }), React.createElement(React.Fragment, null, renderMore(options)));
  } else {
    return React.createElement("span", rest, value.map(function (t, idx) {
      return React.createElement(React.Fragment, {
        key: idx
      }, render(t, idx), idx < value.length - 1 ? separator : null);
    }));
  }
};

ListFormatter.defaultProps = {
  fallback: React.createElement(MissingValue, null),
  separator: ', ',
  maxCount: 0,
  renderMore: function renderMore() {},
  render: function render(item) {
    return item;
  }
};
export default ListFormatter;